import script from "./submitConfirmationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./submitConfirmationModal.vue?vue&type=script&setup=true&lang=js"

import "./submitConfirmationModal.vue?vue&type=style&index=0&id=46b8fac0&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b8fac0"]])

export default __exports__